import React, {useEffect, useState} from 'react';
import styles from "./ConfirmProjectRequestPopUp.module.css";
import Modal from "react-modal";
import {RequestStatus} from "../../../types/request";
import {confirmProjectRequestAPI} from "../../../services/admin";
import {ConfirmProjectRequestRequest} from "../../../types/admin";

interface ConfirmProjectRequestPopUpProps {
    isOpen: boolean;
    onClose: () => void;
    requestId: number | undefined;
}

// 프로젝트 추가 요청 처리 팝업
const ConfirmProjectRequestPopUp: React.FC<ConfirmProjectRequestPopUpProps> = ({
                                                                                   isOpen,
                                                                                   onClose,
                                                                                   requestId
                                                                               }) => {
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [formData, setFormData] = useState<ConfirmProjectRequestRequest>({
        requestId: 0,
        requestStatus: RequestStatus.승인,
        comment: '',
    });

    useEffect(() => {
        if (requestId) {
            setFormData({
                requestId: requestId,
                requestStatus: RequestStatus.승인,
                comment: '',
            });
        }
    }, [requestId]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!requestId) return;

        setIsSubmitting(true);

        try {
            // 프로젝트 추가 요청 처리 API
            await confirmProjectRequestAPI(formData);
            onClose();
        } catch (error) {
            console.error('Error: ', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    // 요청 처리 상태가 추가견적, 반려인 경우 사유 출력
    const showCommentField = formData.requestStatus === RequestStatus.반려 ||
        formData.requestStatus === RequestStatus.추가견적;

    const isSubmitDisabled = !requestId ||
        isSubmitting ||
        (showCommentField && !formData.comment.trim());

    const handleStatusChange = (status: RequestStatus) => {
        setFormData(prev => ({
            ...prev,
            requestStatus: status,
            comment: status === RequestStatus.승인 ? '' : prev.comment
        }));
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className={styles.modal}
            overlayClassName={styles.overlay}
        >
            <div className={styles.container}>
                <div className={styles.header}>
                    <h2 className={styles.title}>프로젝트 추가 요청 처리</h2>
                    {/*팝업 닫기 버튼*/}
                    <button
                        onClick={onClose}
                        className={styles.closeButton}
                        aria-label="Close"
                        disabled={isSubmitting}
                    >
                        ×
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className={styles.formGroup}>
                        <label>처리</label>
                        {/*프로젝트 추가 요청 처리 상태 선택*/}
                        <select
                            value={formData.requestStatus}
                            onChange={(e) => handleStatusChange(e.target.value as RequestStatus)}
                            className={styles.select}
                            required
                            disabled={isSubmitting}
                        >
                            <option value={RequestStatus.승인}>{RequestStatus.승인}</option>
                            <option value={RequestStatus.반려}>{RequestStatus.반려}</option>
                            <option value={RequestStatus.추가견적}>{RequestStatus.추가견적}</option>
                        </select>
                    </div>

                    {showCommentField && (
                        <div className={styles.formGroup}>
                            <label>사유</label>
                            {/*반려, 추가견적 처리 시 사유 작성*/}
                            <textarea
                                value={formData.comment}
                                onChange={(e) => setFormData(prev => ({
                                    ...prev,
                                    comment: e.target.value
                                }))}
                                className={styles.textarea}
                                placeholder={`${formData.requestStatus} 사유를 입력해주세요`}
                                rows={8}
                                required
                                disabled={isSubmitting}
                            />
                        </div>
                    )}

                    {/*처리 버튼*/}
                    <button
                        type="submit"
                        className={styles.submitButton}
                        disabled={isSubmitDisabled}
                    >
                        {isSubmitting ? '처리 중...' : '처리'}
                    </button>
                </form>
            </div>
        </Modal>
    );
}

export default ConfirmProjectRequestPopUp;